import { MENU_ACTIONS } from 'config';

export function activeItem(payload) {
    return {
        type: MENU_ACTIONS.ACTIVE_ITEM,
        payload
    }
}

export function activeID(payload) {
    return {
        type: MENU_ACTIONS.ACTIVE_ID,
        payload
    }
}

export function activeComponent(payload) {
    return {
        type: MENU_ACTIONS.ACTIVE_COMPONENT,
        payload
    }
}

export function openDrawer(payload) {
    return {
        type: MENU_ACTIONS.OPEN_DRAWER,
        payload
    }
}

export function openComponentDrawer(payload) {
    return {
        type: MENU_ACTIONS.OPEN_COMPONENT_DRAWER,
        payload
    }
}

export function hasError(payload) {
    return {
        type: MENU_ACTIONS.HAS_ERROR,
        payload
    }
}